import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveHeight } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import UserProfileHeight from '../../../components/user-profile-height';

import './index.css';

class CurrentHeightPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      metricHeight: props.initialValue,
      unitSystem: props.initialUnit,
    };
  }

  save = async () => {
    try {
      await this.props.saveHeight(this.state.metricHeight, this.state.unitSystem);
    } catch (e) {
      /* do nothing */
    }
  }

  setHeight = (metricHeight, unitSystem) => {
    this.setState({ metricHeight, unitSystem });
  }

  render() {
    return (
      <SettingsContainer
        className="current-height-page"
        pageTitle="What's your height?"
        save={ this.save }
        hideSkip={ this.props.appName === 'wolf' }
        isValid={ Boolean(this.state.metricHeight) }
      >
        <UserProfileHeight setHeight={ this.setHeight } initialValue={ this.state.metricHeight } initialUnit={ this.state.unitSystem } />
      </SettingsContainer>
    );
  }
}

CurrentHeightPage.propTypes = {
  initialValue: PropTypes.number.isRequired,
  initialUnit: PropTypes.string.isRequired,
  saveHeight: PropTypes.func.isRequired,
  appName: PropTypes.string,
};

CurrentHeightPage.defaultProps = {
  initialValue: 153,
  initialUnit: 'standard',
};

export default connect(
  state => ({
    initialValue: state.user.height ? state.user.height * 100 : undefined,
    initialUnit: state.user.units,
    appName: state.config.appName,
  }),
  dispatch => ({
    saveHeight: (height, unitSystem) => dispatch(saveHeight(height, unitSystem))
  }),
  null,
  { withRef: true }
)(CurrentHeightPage);
